import Filters from './Filters';
import Picker from './Picker';
import SortByValue from './SortByValue';
import Pagination from './Pagination/Pagination';
import {ContentContext} from "../../../../utils/contexts";

export default class TopMenu extends React.PureComponent {
  render() {
    const { multiSelect, content, type, searchMode } = this.context;

    return (
      <div className="Top-Menu">
        {!searchMode && <Filters />}
        {!searchMode && content.length > 0 && <SortByValue />}
        {multiSelect && content.length > 0 && content.some(item => item.type === type) && <Picker />}
        {content.length > 0 && <Pagination />}
      </div>
    );
  }
}

TopMenu.contextType = ContentContext;
